<template>
  <span v-editable="blok">
    <b-nav-item v-if="basket" :href="basket.webUrl">
      <span :class="classes">
        <span>{{ blok.label }}</span>
        <span v-if="blok.show_value"> (<span v-mny="{ input: value, currency: '£' }"></span>)</span>
      </span>
    </b-nav-item>
  </span>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "basket-button",
  props: {
    blok: Object
  },
  computed: {
    ...mapState({
        meal_plan: state => state.profile.meal_preferences.meal_plan,
        discount_percent: state => state.basket.discountPercent
    }),
    ...mapGetters({
        basketValue: 'basket/total'
    }),
    classes: function() {
      return [this.$props.blok.classes].join(" ");
    },
    value: function() {
        const f = this.$options.filters;
        const val = f.currency(f.grossAmount(f.discount(this.basketValue, this.discount_percent), 0.2),'£');
        return val;
    }
  }
};
</script>
